// src/pages/AllianceManagement.js

import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import AllianceTechnologyTab from './AllianceManagement/AllianceTechnologyTab';
import AllianceInstituteTab from './AllianceManagement/AllianceInstituteTab';
import './css/AllianceManagement.css';
import { AdminTabs, PageShell, SectionCard } from '../components/ui';

const ALLIANCE_MANAGEMENT_TABS = [
  { value: 'technology', label: 'Alliance Technology' },
  { value: 'institute', label: 'Institute' },
];

const AllianceManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const validTabs = useMemo(() => new Set(ALLIANCE_MANAGEMENT_TABS.map((tab) => tab.value)), []);
  const requestedTab = searchParams.get('tab');
  const activeTab = validTabs.has(requestedTab) ? requestedTab : 'technology';

  const setActiveTab = (nextTab) => {
    setSearchParams({ tab: validTabs.has(nextTab) ? nextTab : 'technology' });
  };

  return (
    <PageShell maxWidth="xl">
      <div className="alliance-management-page">
        <AdminTabs tabs={ALLIANCE_MANAGEMENT_TABS} value={activeTab} onChange={setActiveTab} className="am-tab-menu" />

        <div className="am-tab-dropdown">
          <select value={activeTab} onChange={(e) => setActiveTab(e.target.value)}>
            <option value="technology">Alliance Technology</option>
            <option value="institute">Institute</option>
          </select>
        </div>

        <SectionCard className="am-tab-content" sx={{ p: { xs: 1.5, md: 2 } }}>
          {activeTab === 'technology' && <AllianceTechnologyTab />}
          {activeTab === 'institute' && <AllianceInstituteTab />}
        </SectionCard>
      </div>
    </PageShell>
  );
};

export default AllianceManagement;
